import "./WhyChoose.css";
import {
  FaCheckCircle,
  FaLaptopCode,
  FaHeadset,
  FaRocket
} from "react-icons/fa";

function WhyChoose() {

  const items = [
    {
      icon: <FaLaptopCode />,
      title: "Experienced Developers",
      text: "Modern websites, software and business applications."
    },
    {
      icon: <FaRocket />,
      title: "Fast Delivery",
      text: "Projects delivered on time with high quality."
    },
    {
      icon: <FaHeadset />,
      title: "Lifetime Support",
      text: "Quick support whenever your business needs us."
    },
    {
      icon: <FaCheckCircle />,
      title: "Affordable Pricing",
      text: "Professional solutions at reasonable prices."
    }
  ];

  return (

<section className="why" id="why">

<div className="container">

<div className="row align-items-center">

<div className="col-lg-6">

<h5>WHY CHOOSE US</h5>

<h2>
We Create Digital
Solutions That
Grow Your Business
</h2>

<p>

At Potech Technologies we focus on quality,
performance, security and user experience.

We don't just build websites,
we build your digital identity.

</p>

</div>

<div className="col-lg-6">

<div className="row g-4">

{items.map((item,index)=>(

<div className="col-6" key={index}>

<div className="why-card">

<div className="why-icon">

{item.icon}

</div>

<h4>{item.title}</h4>

<p>{item.text}</p>

</div>

</div>

))}

</div>

</div>

</div>

</div>

</section>

  )

}

export default WhyChoose;